import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../config/authAxios"


const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const saveCurrentCityAction = createAsyncThunk(
    'save-current-city',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/pwa/api/save-current-city`,{...data})
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const saveCurrentCitySlice = createSlice({
    name: 'save-current-city',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(saveCurrentCityAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(saveCurrentCityAction.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(saveCurrentCityAction.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const saveCurrentCityReducer = saveCurrentCitySlice.reducer